export const StorageKeys = {
    theme: 'theme',
    drawerWidth: 240,
    clientIp:'clientIp',
    clientIsLocal:'clientIsLocal',
}

export const Consts={
    drawerWidth: 240,    
}